"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var common_components_1 = require("@l2p/common-components");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_virtuoso_1 = require("react-virtuoso");
var CategoriesList_1 = __importDefault(require("../CategoriesList"));
var providersSelectButton_1 = __importDefault(require("../ProvidersSelectButton/providersSelectButton"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useSearchBarMobile_1 = __importDefault(require("./talons/useSearchBarMobile"));
var GameCollection_1 = __importDefault(require("./GameCollection"));
var SearchBarMobile = function (_a) {
    var _b;
    var gameCardPlaceholder = _a.gameCardPlaceholder;
    var _c = (0, useSearchBarMobile_1.default)(), closeModal = _c.closeModal, isCategoryMode = _c.isCategoryMode, isCategoriesOpened = _c.isCategoriesOpened, searchValue = _c.searchValue, _d = _c.games, games = _d === void 0 ? [] : _d, categories = _c.categories, currentCategory = _c.currentCategory, handleSearchInputChange = _c.handleSearchInputChange, handleSearchInputClear = _c.handleSearchInputClear, handleClickOpenCategories = _c.handleClickOpenCategories, handleSetCurrentCategory = _c.handleSetCurrentCategory;
    var t = (0, next_intl_1.useTranslations)();
    var globalConfig = (0, swr_hooks_1.useConfig)();
    var containerRef = (0, react_1.useRef)(null);
    var data = (0, swr_hooks_1.useGamesByCategories)().data;
    var hasActiveFilter = Boolean(currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id);
    var initialStateInSearchGames = (0, react_1.useMemo)(function () {
        var _a;
        var hasSearchQuery = Boolean(searchValue && searchValue.length >= 3);
        var defaultState = (react_1.default.createElement("div", { className: styles_module_scss_1.default.gamesPlaceholder, dangerouslySetInnerHTML: {
                __html: hasSearchQuery
                    ? t('translation.noResultsFound', {
                        search: searchValue,
                    })
                    : hasActiveFilter
                        ? t.raw('searchBar.empty')
                        : t.raw('searchBar.start'),
            } }));
        if (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.searchBarMobileShowCategoriesByDefault)
            return hasActiveFilter || hasSearchQuery ? (defaultState) : (react_1.default.createElement(react_1.default.Fragment, null, (_a = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.searchBarMobileShowCategoriesByDefault) === null || _a === void 0 ? void 0 : _a.map(function (category) {
                var _a;
                return (react_1.default.createElement("div", { key: "searchCategoriesInDefaultState".concat(category), style: { zIndex: '10' } },
                    react_1.default.createElement(GameCollection_1.default, { gameCardPlaceholder: gameCardPlaceholder, category: category, categoryTitle: (_a = data === null || data === void 0 ? void 0 : data[category]) === null || _a === void 0 ? void 0 : _a.title })));
            })));
        return defaultState;
        //eslint-disable-next-line
    }, [
        currentCategory,
        searchValue,
        globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.searchBarMobileShowCategoriesByDefault,
        data,
        gameCardPlaceholder,
        t,
        hasActiveFilter,
    ]);
    var customScrollParent = (_b = containerRef.current) !== null && _b !== void 0 ? _b : undefined;
    return (react_1.default.createElement(ui_components_1.Modal, { className: styles_module_scss_1.default.modal, onClose: closeModal, padding: "0", width: "360", height: "566" },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container, ref: containerRef },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
                react_1.default.createElement(ui_components_1.SearchInput, { value: searchValue, onChange: handleSearchInputChange, onClear: function () {
                        handleSearchInputClear();
                    }, isMobile: true, withAutoFocus: true }),
                (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.searchBarMobileProviderSearchLight) &&
                    isCategoryMode &&
                    (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && (react_1.default.createElement("div", { className: styles_module_scss_1.default.providersHeader },
                    react_1.default.createElement("div", null, searchValue && searchValue.length > 3 && (react_1.default.createElement(react_1.default.Fragment, null, t('searchBar.searchQuery', { searchValue: searchValue })))),
                    react_1.default.createElement(common_components_1.ProvidersSelectLight, { provider: currentCategory, setProvider: handleSetCurrentCategory, items: categories, allLabelKey: "allCategories" }))),
                isCategoryMode && (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(providersSelectButton_1.default, { isOpened: isCategoriesOpened, onClick: handleClickOpenCategories, labelKey: "translation.categories" }),
                    react_1.default.createElement(CategoriesList_1.default, { currentCategoryId: currentCategory === null || currentCategory === void 0 ? void 0 : currentCategory.id, isOpened: isCategoriesOpened, categories: categories, onItemClick: handleSetCurrentCategory })))),
            games.length ? (react_1.default.createElement(react_virtuoso_1.VirtuosoGrid, { customScrollParent: customScrollParent, totalCount: games.length, overscan: 400, listClassName: styles_module_scss_1.default.gameItemWrapper, itemContent: function (index) {
                    var game = games[index];
                    if (!game)
                        return null;
                    return (react_1.default.createElement(ui_components_1.MobileGameCard, { title: game.title, gameId: game.id, slug: game === null || game === void 0 ? void 0 : game.slug, gameCardPlaceholder: gameCardPlaceholder, gameInfoModalKey: apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL }));
                } })) : (initialStateInSearchGames))));
};
exports.default = SearchBarMobile;
